import './blog.css';
import { useNavigate } from "react-router-dom";
import { Paragraph } from '../basic/title';

const Blogcard = ({ allblog }) => {
    const navigate = useNavigate();

    const handleDetailsRow = (id) => {
        navigate(`/blog/${id}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="grid grid-cols-12 gap-6">
            {allblog.map((item, index) => (
                <div
                    key={index}
                    className="md:col-span-6 lg:col-span-4 col-span-12 flex flex-col justify-center relative cursor-pointer h-full items-center blog_card"
                    onClick={() => handleDetailsRow(item.id)}
                >
                    <div className="w-full h-[250px] overflow-hidden rounded-t-lg">
                        <img
                            src={item.image}
                            alt={item.title}
                            className="object-cover w-full h-full hover:scale-105 transition-transform duration-300"
                        />
                    </div>

                    <div className="py-4 px-2 w-full text-center">
                        <h2 className="text-white font-dm text-lg capitalize font-medium mb-2">
                            {item.title}
                        </h2>

                        <div className="flex flex-col justify-center items-center gap-1">
                            <Paragraph title={item.date} color="#00A762" />
                            <Paragraph title={`${item.views || 0} Views`} color="#00A762" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Blogcard;
